// types
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  role: localStorage.getItem("role") || ["Applicant"],
  user: localStorage.getItem("user_details")
    ? JSON.parse(localStorage.getItem("user_details"))
    : {},
};

// ==============================|| SLICE - MENU ||============================== //

const user = createSlice({
  name: "user",
  initialState,
  reducers: {
    ROLE_SET: (state, payload) => {
      localStorage.setItem("role", JSON.stringify(payload.payload));
      return {
        ...state,
        role: payload.payload,
      };
    },
    USER_SET: (state, payload) => {
      localStorage.setItem("user_details", JSON.stringify(payload.payload));
      return {
        ...state,
        user: payload.payload,
      };
    },
  },
});

export default user.reducer;

export const { ROLE_SET, USER_SET } = user.actions;
